import dateFormat from "dateformat";
import Image from "next/image";

const CheapestCarCard = ({
  prepaid,
  carImg,
  rev,
  luggage,
  category,
  passengers,
  size,
  name,
  doors,
  cost,
  airconditioning,
  data,
  providerLogo,
  totalPrice,
  sites,
  bookUrl,
  policies,
  fuel,
}: {
  prepaid: boolean;
  carImg: string;
  luggage?: string;
  passengers: number;
  category: string;
  size: string;
  name: string;
  doors?: string;
  cost: string;
  airconditioning?: boolean;
  data: any;
  providerLogo: string;
  totalPrice: any;
  sites: any;
  bookUrl: string;
  policies: any;
  rev?: boolean;
  fuel?: string;
}) => {
  const handleBooking = () => {
    window.open(
      `http://kayak.com${parseUrl(
        bookUrl
      )}?sort=rank_a&fs=carclass=${category}`,
      "_blank"
    );
  };
  const today = new Date();

  const parseUrl = (url: string) => {
    const selectedDate =
      today.getHours() >= 12
        ? new Date(new Date().setDate(today.getDate() + 1))
        : today;
    let urlArr = url.split("/");
    if (urlArr[1] === "book") return urlArr.join("/");
    urlArr[3] = `${dateFormat(selectedDate, "yyyy-mm-dd")}`;
    urlArr[4] = `${dateFormat(
      new Date().setDate(selectedDate.getDate() + 1),
      "yyyy-mm-dd"
    )}`;
    const newUrl = urlArr.join("/");
    return newUrl;
  };

  return (
    <div className="flex flex-col justify-between h-full">
      <div className="flex flex-row items-center justify-start car-card-shadow rounded-t-[16px] rounded-b-[6px] lg:rounded-[22px] border-[#E5EAF6] border-l border-t border-r  h-full w-full">
        <div className="lg:border-r flex flex-col items-start justify-center px-[10px] lg:px-[22px] h-full lg:min-w-[208px]">
          <h3 className="font-bold text-[26px] text-my-dark-blue hidden lg:flex leading-7 flex-col">
            {rev ? size : name}{" "}
            {!rev && (
              <span className="text-sm text-[#595959] font-medium -mt-[2px]">
                or Similar
              </span>
            )}
          </h3>
          <p className="font-medium text-base text-my-dark-blue mt-[3px] hidden lg:flex flex-col">
            {rev ? name : size}{" "}
            {rev && (
              <p className="text-sm text-[#595959] font-medium -mt-1">
                or Similar
              </p>
            )}
          </p>
          {providerLogo === "loading" ? (
            <div className="animate-pulse bg-[#E5EAF6] h-[22px] w-[54px] rounded-full mt-3 mb-[14px] block lg:hidden" />
          ) : (
            <img
              loading="lazy"
              src={providerLogo}
              width={40}
              height={16}
              alt="Provider logo"
              className="mt-3 mb-[14px] block lg:hidden"
            />
          )}

          <img
            loading="lazy"
            src={`/cars/class-img/${category}.png`}
            width={185}
            height={126}
            alt={`Rent ${name}`}
          />
        </div>
        <div className="flex flex-col justify-between w-full h-full">
          <div className="p-[8px] pb-[10px] lg:pb-0 lg:px-[22px] pt-[18px]">
            <h3 className="font-bold text-[16px] text-my-dark-blue lg:hidden flex flex-col">
              {rev ? size : name}{" "}
              {!rev && (
                <span className="text-sm text-[#595959] font-medium -mt-1">
                  or Similar
                </span>
              )}
            </h3>
            <p className="font-medium text-[13px] text-my-dark-blue mt-[2px] lg:hidden flex flex-col mb-3">
              {rev ? name : size}{" "}
              {rev && (
                <p className="text-sm text-[#595959] font-medium -mt-1">
                  or Similar
                </p>
              )}
            </p>
            <div className="text-my-dark-blue font-medium text-[13px] flex flex-wrap  gap-[6px] lg:gap-2">
              {luggage && (
                <div className="border-[0.7px] border-[#D8DFEE] rounded-full  px-[6px] lg:p-2 flex items-center justify-center gap-[2px]">
                  <Image
                    src="/drive-around-icons/baggage.svg"
                    width={20}
                    height={20}
                    alt="Fan icon"
                  />
                  <p className="w-full">{luggage}</p>
                </div>
              )}
              {passengers && (
                <div className="border-[0.7px] border-[#D8DFEE] rounded-full  p-[6px] lg:p-2 flex items-center justify-center gap-[2px]">
                  <Image
                    src="/drive-around-icons/users.svg"
                    width={20}
                    height={20}
                    alt="Fan icon"
                  />
                  <p className="flex w-full gap-2 ">
                    {passengers?.toString()}{" "}
                    <span className="hidden lg:block">Passengers</span>
                  </p>
                </div>
              )}
              {doors && (
                <div className="border-[0.7px] border-[#D8DFEE] rounded-full  p-[6px] lg:p-2 flex items-center justify-center gap-[2px]">
                  <Image
                    src="/drive-around-icons/door.svg"
                    width={20}
                    height={20}
                    alt="Fan icon"
                  />
                  <p className="flex w-full gap-2">
                    {doors} <span className="hidden lg:block">doors</span>
                  </p>
                </div>
              )}
              {airconditioning && (
                <div className="border-[0.7px] border-[#D8DFEE] rounded-full  p-[6px] lg:p-2 flex items-center justify-center gap-[2px]">
                  <Image
                    src="/drive-around-icons/fan.svg"
                    width={20}
                    height={20}
                    alt="Fan icon"
                  />
                  <p className="hidden lg:block">Air conditioning</p>
                  <p className="block lg:hidden">AC</p>
                </div>
              )}
            </div>
            <div className="mt-4 flex flex-wrap gap-x-[22px] gap-y-[10px]">
              {policies &&
                policies.map((policy: any, index: number) => {
                  return (
                    <div
                      key={index}
                      className="flex items-center justify-center gap-[6px]"
                    >
                      <Image
                        src="/airport/airport-drive-around/tick-circle.svg"
                        height={17}
                        width={17}
                        alt="Tick icon"
                      />
                      <p className="font-normal text-sm text-my-light-blue leading-[21px]">
                        {policy?.valueDisplay}
                      </p>
                    </div>
                  );
                })}
              {prepaid && (
                <div className="flex items-center justify-center gap-[6px]">
                  <Image
                    src="/airport/airport-drive-around/tick-circle.svg"
                    height={17}
                    width={17}
                    alt="Tick icon"
                  />
                  <p className="font-normal text-sm text-my-light-blue leading-[21px]">
                    Prepaid
                  </p>
                </div>
              )}
              {fuel && (
                <div className="flex items-center justify-center gap-[6px]">
                  <Image
                    src="/airport/airport-drive-around/tick-circle.svg"
                    height={17}
                    width={17}
                    alt="Tick icon"
                  />
                  <p className="font-normal text-sm text-my-light-blue leading-[21px]">
                    {fuel[0] + fuel.slice(1).toLowerCase()}
                  </p>
                </div>
              )}
            </div>
            {providerLogo === "loading" ? (
              <div className="h-[22px] w-[54px] rounded-full mt-3 mb-[14px] hidden lg:block" />
            ) : (
              <img
                loading="lazy"
                src={providerLogo}
                width={54}
                height={22}
                alt="Provider logo"
                className="mt-3 mb-[14px] hidden lg:block"
              />
            )}
          </div>
          <div>
            <div className="hidden w-full lg:block border border-[#E5EAF6] border-dashed" />
            <div className=" py-[23px]  justify-between items-center hidden lg:flex w-full px-[22px]">
              <div>
                <p className="font-bold text-xl text-[#0057FF]">
                  {cost === "loading" ? <></> : `${cost}/Day`}
                </p>
                <p className="text-sm text-my-dark-blue leading-[19px] opacity-70 mt-[3px]">
                  {/* {totalPrice === "loading" ? (
                    <></>
                  ) : (
                    `${cost[0]}${totalPrice} total (from ${sites} sites)`
                  )} */}
                  {totalPrice === "loading" ? (
                    <></>
                  ) : (
                    <>
                      From{" "}
                      <strong className="font-bold">{data.agency.name}</strong>{" "}
                      car rentals
                    </>
                  )}
                </p>
              </div>

              <button
                onClick={handleBooking}
                className="search-btn-gradient font-semibold text-lg text-white py-4 px-11 leading-[21px] rounded-[14px] ml-auto"
              >
                {cost === "loading" ? "Check Prices" : "Book"}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="w-[98%] mx-auto h-[1px] border border-dashed lg:hidden flex"></div>
      <div className="px-[22px] py-[23px]  justify-between items-center lg:hidden flex border-b border-l border-r rounded-t-[6px] rounded-b-[16px]">
        <div>
          <p className="font-bold text-xl text-[#0057FF]">
            {cost === "loading" ? <></> : `${cost}/Day`}
          </p>
          <p className="text-sm text-my-dark-blue leading-[19px] opacity-70 mt-[3px]">
            {/* {totalPrice === "loading" ? (
              <></>
            ) : (
              `${cost[0]}${totalPrice} total (from ${sites} sites)`
            )} */}
            {totalPrice === "loading" ? (
              <></>
            ) : (
              <>
                From <strong className="font-bold">{data.agency.name}</strong>{" "}
                car rentals
              </>
            )}
          </p>
        </div>
        <button
          onClick={handleBooking}
          className="search-btn-gradient font-semibold text-lg text-white py-4 px-11 leading-[21px] rounded-[14px]"
        >
          {cost === "loading" ? "Check Prices" : "Book"}
        </button>
      </div>
    </div>
  );
};

export default CheapestCarCard;
